// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2RP4C","icon":"icon___WWJsf","text":"text___2dHr7"};